module.exports = __webpack_public_path__ + "static/media/outer_34.11a22324.jpg";